import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendLog } from "../utils/sendLog";
import userStore from "../store/userStore";

const usePageViewLogger = () => {
  const { pathname } = useLocation();
  const { userId, sessionId } = userStore();

  useEffect(() => {
    // Only log if userId and sessionId are available
    if (userId && sessionId) {
      sendLog("page_view", {
        page: pathname,
        action: `On ${pathname.slice(1)} page`,
      });
    }
  }, [pathname, userId, sessionId]);
};

export default usePageViewLogger;
